import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { User } from '../../_models/user';

const REST_API_SERVER = environment.apiHost;

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private API_URL = REST_API_SERVER + "services/v1.0/";
  private currentUserSubject: BehaviorSubject<User>; // observes current logged in/registered user info
  public currentUser: Observable<User>;// holds current logged in/registered user info

  constructor(private httpClient: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public loginWithEmail(data: any) {
    var url = this.API_URL;
    return this.httpClient.post<any>(url + "auth/user/login/email", data, {
      observe: 'response'
    })
      .pipe(
        retry(0),
        catchError(this.handleError)
      );
  }

  public loginVerifyOTP(data: any) {
    var url = this.API_URL;
    return this.httpClient.post<any>(url + "auth/user/verify/login/otp", data, {
      observe: 'response'
    })
      .pipe(
        map(res => {
          // login successful if there's a jwt token in the response
          if (res && res.body && res.body.user) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(res.body.user));
            this.currentUserSubject.next(res.body.user);
          }
          return res;
        }),
        retry(0),
        catchError(this.handleError)
      );
  }

  public loginProvider(data: any) {
    var url = this.API_URL;
    return this.httpClient.post<any>(url + "auth/user/login/provider", data, {
      observe: 'response'
    })
      .pipe(
        map(res => {
          // login successful if there's a jwt token in the response
          if (res && res.body && res.body.user) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(res.body.user));
            this.currentUserSubject.next(res.body.user);
          }
          return res;
        }),
        retry(0),
        catchError(this.handleError)
      );
  }

  public registerWithEmail(data: any) {
    var url = this.API_URL;
    return this.httpClient.post<any>(url + "auth/user/register/email", data, {
      observe: 'response'
    })
      .pipe(
        retry(0),
        catchError(this.handleError)
      );
  }

  public registrationVerifyOTP(data: any) {
    var url = this.API_URL;
    return this.httpClient.post<any>(url + "auth/user/verify/register/otp", data, {
      observe: 'response'
    })
      .pipe(
        map(res => {
          // login successful if there's a jwt token in the response
          if (res && res.body && res.body.user) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(res.body.user));
            this.currentUserSubject.next(res.body.user);
          }
          return res;
        }),
        retry(0),
        catchError(this.handleError)
      );
  }

  public registrationProvider(data: any) {
    var url = this.API_URL;
    return this.httpClient.post<any>(url + "auth/user/register/provider", data, {
      observe: 'response'
    })
      .pipe(
        map(res => {
          // login successful if there's a jwt token in the response
          if (res && res.body && res.body.user) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(res.body.user));
            this.currentUserSubject.next(res.body.user);
          }
          return res;
        }),
        retry(0),
        catchError(this.handleError)
      );
  }

  public logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    //   this.socialAuthService.signOut(); // logout all Social login sessions.
  }

  public isLoggedIn() : Observable<User> {
    return this.currentUser;
   }

  private handleError(error: HttpErrorResponse) {
    debugger;
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `${error.error.msg}`;
    }
    return throwError(errorMessage);
  }
  public verifyWithEmail(data:any){
    console.log('data--==',data);
    
    var url = this.API_URL;
    return this.httpClient.post<any>(url + 'auth/user/login/email',data,{
      observe:"response",
    })
    .pipe(retry(2),catchError(this.handleError));
  }
}
